import styled from 'styled-components';
import { MapPin, Phone, Mail } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Correction pour l'icône du marqueur
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Contact = () => {
  return (
    <ContactContainer>
      <ContactHeader>
      <h1>Échangeons sur<span> votre projet</span></h1>
 <p>
   Partagez vos ambitions digitales avec nos experts. 
   Ensemble, créons des solutions innovantes qui répondent 
   à vos enjeux technologiques et business.
 </p>
      </ContactHeader>

      <FormContainer>
        <FormGrid>
          <Input type="text" placeholder="Votre nom" />
          <Input type="text" placeholder="Votre prénom" />
          <Input type="email" placeholder="Email" />
          <Input type="tel" placeholder="+32" />
          <Input type="text" placeholder="Société" />
          <Select defaultValue="">
            <option value="" disabled>Sujet ---</option>
            <option value="cloud">Cloud Computing</option>
            <option value="data">Ingénierie des Données</option>
            <option value="project">Gestion de Projet</option>
          </Select>
          <TextArea placeholder="Votre message..." />
          <SubmitButton>Envoyer le message</SubmitButton>
        </FormGrid>

        <InfoText>
 Vos informations personnelles sont traitées par DataVision Solutions uniquement 
 pour répondre à votre demande et améliorer nos services.
</InfoText>
<InfoText>
 En accord avec le RGPD, vous bénéficiez d'un droit d'accès, de modification et de 
 suppression de vos données. Consultez notre politique de confidentialité pour plus 
 de détails sur la gestion de vos informations.
</InfoText>
      </FormContainer>

      <ContactInfo>
        <h2>Nos coordonnées</h2>
        <MapSection>
          <Map>
            <MapContainer
              center={[50.8503, 4.3517]} // Coordonnées de Paris
              zoom={13}
              scrollWheelZoom={false}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={[50.8503, 4.3517]}>
                <Popup>
                DataVision Solutions <br />
                  Avenue des Archères, 1180 bruxelles
                </Popup>
              </Marker>
            </MapContainer>
          </Map>
          <ContactDetails>
            <div className="detail">
              <MapPin className="icon" />
              <div className="text">
                <h3>Adresse</h3>
                <p>Avenue des Archères, 1180 bruxelles, Belgique</p>
              </div>
            </div>
            <div className="detail">
              <Phone className="icon" />
              <div className="text">
                <h3>Téléphone</h3>
                <p>+32 4 00 00 00 10</p>
              </div>
            </div>
            <div className="detail">
              <Mail className="icon" />
              <div className="text">
                <h3>Email</h3>
                <p>contact@datavision.com</p>
              </div>
            </div>
          </ContactDetails>
        </MapSection>
      </ContactInfo>
    </ContactContainer>
  );
};


export default Contact;


const ContactContainer = styled.div`
  min-height: 100vh;

  padding: 4rem 2rem;
`;

const ContactHeader = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto 4rem;

  h1 {
    font-size: 3.5rem;
    margin-bottom: 1.5rem;
    
    span {
      color: #94a3b8;
    }
  }

  p {
    color: #94a3b8;
    line-height: 1.6;
  }
`;

const FormContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const FormGrid = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #2563eb;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  color: #94a3b8;
  font-size: 1rem;
  appearance: none;

  &:focus {
    outline: none;
    border-color: #2563eb;
  }
`;

const TextArea = styled.textarea`
  grid-column: 1 / -1;
  width: 100%;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  color: white;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #2563eb;
  }
`;

const SubmitButton = styled.button`
  grid-column: 1 / -1;
  background: #2563eb;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #1d4ed8;
  }
`;

const InfoText = styled.p`
  text-align: center;
  color: #94a3b8;
  font-size: 0.875rem;
  margin: 2rem 0;
`;

const ContactInfo = styled.div`
  margin-top: 6rem;
  text-align: center;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 3rem;
  }
`;

const MapSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
 gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  border-radius: 1rem;
  overflow: hidden;
   padding: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Map = styled.div`
  height: 400px;
  width: 100%;
  background: #1a1a2e;
  border-radius: 1rem;
    overflow: hidden;

      .leaflet-container {
    height: 100%;
    width: 100%;
    border-radius: 1rem;
  }
 
`;

const ContactDetails = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
   gap: 2rem; // Augmenté l'espace entre les détails
  background: rgba(0, 0, 0, 0.2); // Optionnel: ajoute un fond subtil
  border-radius: 1rem; // Arrondi les coins

  .detail {
    display: flex;
    gap: 1.5rem;
    align-items: flex-start;

    .icon {
      color: #2563eb;
       min-width: 24px;
    }

    .text {
      color: #94a3b8;
      text-align: left;
      
      h3 {
        color: white;
        margin-bottom: 0.5rem;
        font-size: 1.2rem
      }
    }
  }
`;